<template>
  <button
    type="button"
    class="fullscreen-toggle"
    :title="isFullscreen ? $t('monitorConsole.exitFullscreen') : $t('monitorConsole.fullscreen')"
    @click="handleToggle"
  >
    <svg v-if="!isFullscreen" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"></path>
    </svg>
    <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"></path>
    </svg>
  </button>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'
import {
  isAppFullscreenActive,
  toggleAppFullscreen,
  subscribeAppFullscreen,
} from '@/utils/appFullscreen'

export default {
  name: 'FullscreenToggle',
  setup() {
    const isFullscreen = ref(false)
    let unbindFullscreen = null

    async function syncFullscreen() {
      isFullscreen.value = await isAppFullscreenActive()
    }

    onMounted(async () => {
      await syncFullscreen()
      unbindFullscreen = subscribeAppFullscreen(syncFullscreen)
    })

    onUnmounted(() => {
      unbindFullscreen?.()
      unbindFullscreen = null
    })

    async function handleToggle() {
      await toggleAppFullscreen()
      await syncFullscreen()
    }

    return { isFullscreen, handleToggle }
  },
}
</script>

<style scoped>
.fullscreen-toggle {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  color: var(--mc-body);
  background: transparent;
  border: none;
  border-radius: var(--mc-radius-md);
  cursor: pointer;
  transition: background var(--mc-transition-fast);
}

.fullscreen-toggle svg {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.fullscreen-toggle:active {
  background: var(--mc-surface-soft);
}
</style>
